<template>
  <section
    :class="[
      'filters-container',
      { 'rtl-set': $t('lang') == 'ar' },
      { 'set-l': $t('lang') == 'ar' },
    ]"
  >
    <div class="disktop-filter">
      <h6>{{ $t("listingPage.filters") }}</h6>
    </div>
    <div class="mobile-filter" @click="openFilter">
      <h6>{{ $t("listingPage.filters") }}</h6>
    </div>
    <div class="filter-buttons">
      <v-col cols="12" class="py-2">
        <v-btn-toggle
          v-model="filter_type"
          rounded="xl"
          color="deep-purple-accent-3"
          style="border: 1px solid #f2f2f2"
          group
        >
          <v-btn value="default" @click="setSorting">
            {{ $t("tabFilter.default") }}
          </v-btn>

          <v-btn value="close_to_me" @click="setSorting">
            {{ $t("tabFilter.close_to_me") }}
          </v-btn>

          <v-btn value="top_rated" @click="setSorting">
            {{ $t("tabFilter.top_rated") }}
          </v-btn>

          <v-btn value="most_viewed" @click="setSorting">
            {{ $t("tabFilter.most_viewed") }}
          </v-btn>

          <v-btn value="lowest_price" @click="setSorting">
            {{ $t("tabFilter.lowest_price") }}
          </v-btn>

          <v-btn value="highest_price" @click="setSorting">
            {{ $t("tabFilter.highest_price") }}
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </div>
  </section>
</template>

<script>
export default {
  name: "ApartFilter",
  data() {
    return {
      filter_type: "default",
      filters: {},
    };
  },
  mounted() {
    var q = this.$route.query;
    delete q.page;
    this.filters = q;
  },
  methods: {
    openFilter() {
      this.$emit("openFilterMobile");
    },
    pushUrl() {
      var url = this.constructURL("/", "search", this.filters) + "page=1";
      this.$router.push(url);
    },
    constructURL(url, category, fl) {
      if (category) url += category + "?";
      Object.keys(fl).forEach((e) => {
        // && fl[e].length > 0
        if (fl[e] && fl[e] !== "undefined") url += `${e}=${fl[e]}&`;
      });
      return url;
    },
    setSorting() {
      this.$emit("set-Sorting", this.filter_type);
    },
  },
};
</script>

<style scoped>
.bg-deep-purple-accent-3 {
  background-color: #0e4763 !important;
  color: #ffffff !important;
}
.filters-container {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 15px 0;
}
.filters-container select {
  background: #fff;
}
.filters-container div h6 {
  color: #0e4763;
  font-size: 18px;
}
.filter-buttons {
  display: flex;
}
.filter-buttons .filter-option {
  border: 1px solid #0e4763;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  width: 100%;
}
.filter-buttons .filter-option img {
  width: 15px;
  height: 15px;
  margin-right: 10px;
}
.filter-buttons .filter-option select {
  border: none;
  outline: none;
  color: #0e4763;
  font-size: 14px;
  width: 70%;
  cursor: pointer;
  padding: 10px 0;
}
@media (max-width: 700px) and (min-width: 320px) {
  .filter-buttons {
    visibility: hidden;
  }
  .filter-buttons .filter-option select {
    width: 55%;
  }
  .filter-buttons .filter-option {
    margin-right: 6px;
    width: 125px;
  }
  .filters-container div h6 {
    margin-left: 10px;
  }
  .set-l {
    padding: 15px 10px;
  }
}
</style>
